<template>
  <div
    v-if="request.requestType === 'PQT'"
    class="pqt-extras-simple"
  >
    <div class="extras-header">
      <h3 class="extras-title">{{ $t('pqtExtrasView.ilkinZruriRtlr') }}</h3>
    </div>

    <div class="extras-grid">
      <!-- Currency -->
      <div class="extras-item">
        <div class="item-label">{{ $t('pqtExtrasView.valyuta') }}</div>
        <div class="item-value">
          <span class="value-text">{{ requestExtras.currency }}</span>
          <span
            v-if="requestExtras.currencyRequired==='true'"
            class="requirement-badge required"
          >{{ $t('pqtExtrasView.mtlq') }}</span>
          <span
            v-else
            class="requirement-badge optional"
          >{{ $t('pqtExtrasView.arzuOlunan') }}</span>
        </div>
      </div>

      <!-- Only Vendors -->
      <div class="extras-item">
        <div class="item-label">{{ $t('pqtExtrasView.onlyVendors') }}</div>
        <div class="item-value">
          <span
            v-if="request.onlyVendors"
            class="requirement-badge required"
          >
            {{ $t("newPolRequest.bli") }}
          </span>
          <span
            v-else
            class="requirement-badge optional"
          >
            Xeyr
          </span>
        </div>
      </div>

      <!-- Delivery -->
      <div class="extras-item">
        <div class="item-label">{{ $t('offerExtrasView.atdrlma') }}</div>
        <div class="item-value">
          <div
            v-if="requestExtras.deliveryNeeded === 'true'"
            class="value-with-details"
          >
            <span class="requirement-badge required">
              {{ $t("newPolRequest.bli") }}
            </span>
            <span
              v-if="requestExtras.deliveryAddress"
              class="address-badge"
            >{{ requestExtras.deliveryAddress }}</span>
          </div>
          <span
            v-else
            class="requirement-badge optional"
          >{{ $t('pqtExtrasView.ehtiyacYoxdur') }}</span>
        </div>
      </div>

      <!-- Delivery Time -->
      <div class="extras-item">
        <div class="item-label">{{ $t('offerExtrasView.deliveryTimeNeeded') }}</div>
        <div class="item-value">
          <span
            v-if="requestExtras.deliveryTimeNeeded === 'true'"
            class="requirement-badge required"
          >
            {{ $t("newPolRequest.bli") }}
          </span>
          <span
            v-else
            class="requirement-badge optional"
          >{{ $t('pqtExtrasView.ehtiyacYoxdur') }}</span>
        </div>
      </div>

      <!-- Payment Required -->
      <div class="extras-item">
        <div class="item-label">{{ $t('offerExtrasView.paymentRequired') }}</div>
        <div class="item-value">
          <span
            v-if="requestExtras.paymentRequired === 'true'"
            class="requirement-badge required"
          >
            {{ $t("newPolRequest.bli") }}
          </span>
          <span
            v-else
            class="requirement-badge optional"
          >{{ $t('pqtExtrasView.ehtiyacYoxdur') }}</span>
        </div>
      </div>

      <!-- Guaranty Time -->
      <div class="extras-item">
        <div class="item-label">{{ $t('offerExtrasView.guarantyTime') }}</div>
        <div class="item-value">
          <span
            v-if="requestExtras.guarantyTime === 'true'"
            class="requirement-badge required"
          >
            {{ $t("newPolRequest.bli") }}
          </span>
          <span
            v-else
            class="requirement-badge optional"
          >{{ $t('pqtExtrasView.ehtiyacYoxdur') }}</span>
        </div>
      </div>

      <!-- Producer Country -->
      <div class="extras-item">
        <div class="item-label">{{ $t('offerExtrasView.producerCountry') }}</div>
        <div class="item-value">
          <span
            v-if="requestExtras.countryRequired === 'true'"
            class="requirement-badge required"
          >
            {{ $t("newPolRequest.bli") }}
          </span>
          <span
            v-else
            class="requirement-badge optional"
          >{{ $t('pqtExtrasView.ehtiyacYoxdur') }}</span>
        </div>
      </div>

      <!-- Need Alternative -->
      <div class="extras-item">
        <div class="item-label">{{ $t("pqtExtrasView.needAlternative") }}</div>
        <div class="item-value">
          <span
            v-if="requestExtras.alternativeRequired === 'true'"
            class="requirement-badge required"
          >
            {{ $t("newPolRequest.bli") }}
          </span>
          <span
            v-else
            class="requirement-badge optional"
          >{{ $t('pqtExtrasView.ehtiyacYoxdur') }}</span>
        </div>
      </div>

      <!-- Show Before -->
      <div class="extras-item">
        <div class="item-label">{{ $t('pqtExtrasView.showBefore') }}</div>
        <div class="item-value">
          <span
            v-if="requestExtras.showBefore === 'true'"
            class="requirement-badge required"
          >
            {{ $t("newPolRequest.bli") }}
          </span>
          <span
            v-else
            class="requirement-badge optional"
          >{{ $t('pqtExtrasView.ehtiyacYoxdur') }}</span>
        </div>
      </div>

      <!-- Method (if autoWinner exists) -->
      <div 
        v-if="request.autoWinner"
        class="extras-item"
      >
        <div class="item-label">{{ $t('pqtExtrasView.method') }}</div>
        <div class="item-value">
          <span class="method-badge">
            {{ request.autoWinner === 1 ? $t('newAUCRequest.manual') : $t('newAUCRequest.automatic') }}
          </span>
        </div>
      </div>
    </div>

    <!-- Notes (if they exist) -->
    <div 
      v-if="requestExtras.initialRequirementNotes"
      class="extras-notes"
    >
      <div class="notes-label">{{ $t('pqtExtrasView.qeyd') }}</div>
      <div class="notes-content">{{ requestExtras.initialRequirementNotes }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PQTExtrasView',
  props: {
    request: {},
    requestExtras: {}
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}

/* Modern PQT Extras View Styling */
.pqt-extras-simple {
  padding: 10px 0;
  margin: 10px 0;
}

/* Keeping the original style for reference if needed */
.pqt-extras-container {
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  padding: 20px;
  margin: 20px 0;
  transition: all 0.3s ease;
}

.pqt-extras-container:hover {
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.extras-header {
  margin-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 8px;
}

.extras-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.extras-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 10px;
}

.extras-item {
  padding: 8px;
  background-color: #f8f9fa;
  border-radius: 6px;
  transition: background-color 0.2s ease;
}

.extras-item:hover {
  background-color: #f0f4f8;
}

.item-label {
  font-size: 0.8rem;
  color: #6c757d;
  margin-bottom: 4px;
}

.item-value {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
}

.value-text {
  font-weight: 600;
  color: #333;
  font-size: 0.85rem;
}

.value-with-details {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
}

.requirement-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
}

.requirement-badge.required {
  background-color: #dc3545;
  color: white;
}

.requirement-badge.optional {
  background-color: #e9ecef;
  color: #495057;
}

.address-badge {
  display: inline-block;
  background-color: #6c757d;
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
}

.method-badge {
  display: inline-block;
  background-color: #17a2b8;
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
}

.extras-notes {
  margin-top: 15px;
  padding: 10px;
  background-color: #fff8e1;
  border-left: 3px solid #ffc107;
  border-radius: 3px;
}

.notes-label {
  font-weight: 600;
  color: #6c757d;
  margin-bottom: 5px;
  font-size: 0.85rem;
}

.notes-content {
  color: #333;
  line-height: 1.4;
  font-size: 0.85rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .extras-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }

  .pqt-extras-container {
    padding: 15px;
  }

  .pqt-extras-simple {
    padding: 5px 0;
  }

  .extras-title {
    font-size: 1rem;
  }

  .extras-item {
    padding: 6px;
  }
}

@media (max-width: 576px) {
  .extras-grid {
    grid-template-columns: 1fr;
  }
}
</style>
